import { createSelector } from 'reselect';

export const selectFavoriteAssets = createSelector(
  state => state.favorites,
  favorites => favorites.favoriteAssets
);
